import React, { useEffect, useRef, useState } from 'react';
import styles from '../../assets/scss/InventoryManagement/AddNewItems.module.scss';
import { FaEdit, FaPrint, FaTrashAlt } from 'react-icons/fa';
import Pagination from '../../Components/Common/Pagination';
import { useNavigate } from 'react-router-dom';
import PopupWrapper from '../../Components/Common/PopupWrapper';
import AddItemsPopup from './AddItemsPopup';
import DeleteConfirmModal from '../../Components/Common/DeleteConfirmModal';
import Select from 'react-select';
import { useCreateInventoryMutation, useGetFarmersQuery } from '../../slices/admin/admin';
import { toast } from 'react-toastify';
import DeleteConfirmModalLogout from '../../Components/Common/DeleteConfirmModalLogout';

const AddNewItems = () => {
    const [items, setItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showAddItemPopup, setShowAddItemPopup] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [editItem, setEditItem] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const navigate = useNavigate();

    const [isNewUser, setIsNewUser] = useState(false);
    const [newOwner, setNewOwner] = useState('');
    const [newPhone, setNewPhone] = useState('');
    const [selectedFarmer, setSelectedFarmer] = useState(null);
    const [createInventory, { isLoading: isSubmitting }] = useCreateInventoryMutation();
    const [fieldErrors, setFieldErrors] = useState({});
    const [submitConfirmOpen, setSubmitConfirmOpen] = useState(false);
    const [saleCommission, setSaleCommission] = useState('');

    ///noted backend address added
    console.log(selectedFarmer, "tttttt");


    const {
        data: farmerData,
        isLoading,
        isError,
    } = useGetFarmersQuery();

    const farmerOptions =
        farmerData?.items?.map((farmer) => ({
            value: farmer._id,
            label: `${farmer.storeName ? `${farmer.storeName} - ` : ""}${farmer.phone} - ${farmer.firstName} (Pending: ₹${farmer.totalCreditAmount || 0})`,
            name: farmer.firstName,
            phone: farmer.phone,
            storeName: farmer.storeName
        })) || [];


    useEffect(() => {
        const storedItems = JSON.parse(localStorage.getItem('inventoryItems') || '[]');
        setItems(storedItems);
    }, [showAddItemPopup]);

    const handleClose = () => {
        localStorage.removeItem('inventoryItems');
        navigate('/dashboard/InventoryTable');
    };


    const confirmDelete = () => {
        if (itemToDelete) {
            const updated = items.filter(i => i._id !== itemToDelete._id);
            setItems(updated);
            localStorage.setItem('inventoryItems', JSON.stringify(updated));
        }
        setModalOpen(false);
        setItemToDelete(null);
    };
    const tableRef = useRef();


    const handlePrint = () => {
        if (!tableRef.current) return;

        const clonedTable = tableRef.current.cloneNode(true);

        const ths = clonedTable.querySelectorAll('thead th');
        if (ths.length > 0) {
            ths[ths.length - 1].remove();
        }

        const rows = clonedTable.querySelectorAll('tbody tr');
        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            if (cells.length > 0) {
                cells[cells.length - 1].remove();
            }
        });

        const paginationWrapper = clonedTable.querySelector(`.${styles.paginationWrapper}`);
        if (paginationWrapper) {
            paginationWrapper.remove();
        }

        const printWindow = window.open('', '', 'height=800,width=1000');
        printWindow.document.write(`
      <html>
        <head>
          <title>Inventory Table</title>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
            }
            th, td {
              border: 1px solid #ccc;
              padding: 8px;
              text-align: left;
              font-size: 14px;
            }
            th {
              background-color: #f5f5f5;
            }
            .noData {
              text-align: center;
              padding: 1rem;
              font-style: italic;
              color: #999;
            }
          </style>
        </head>
        <body>
          ${clonedTable.outerHTML}
        </body>
      </html>
    `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };


    const handleSubmit = async () => {
        const farmerName = isNewUser
            ? newOwner.trim()
            : selectedFarmer?.name || selectedFarmer?.label?.split(" - ").pop();

        const farmerPhone = isNewUser
            ? newPhone.trim()
            : selectedFarmer?.phone || selectedFarmer?.label?.split(" - ")[selectedFarmer?.label?.split(" - ").length - 2];

        const errors = {};

        if (!farmerName) errors.farmerName = true;
        if (!farmerPhone) errors.farmerPhone = true;
        if (!saleCommission) errors.saleCommission = true;
        if (!items.length) {
            errors.products = true;
            toast.error('Please add at least one product');
        }

        if (Object.keys(errors).length > 0) {
            setFieldErrors(errors);

            if (!errors.products) {
                toast.error('Please fill all required fields');
            }

            return;
        }

        setFieldErrors({});

        try {
            // const payload = {
            //     farmerName,
            //     farmerPhone,
            //     products: items.map((item) => ({
            //         productName: item.category,
            //         productCount: item.bag !== 'kilogram' ? item.count : undefined,
            //         productQuantity: item.bag === 'kilogram' ? item.quantity : undefined,
            //         productBag: item.bag,
            //         productQuality: item.quantityLevel,
            //         description: item.description,
            //     })),
            // };

            const payload = {
                farmerName,
                farmerPhone,
                saleCommission, // ✅ Add this
                products: items.map((item) => ({
                    productName: item.category,
                    productCount: item.bag !== 'kilogram' ? item.count : undefined,
                    productQuantity: item.bag === 'kilogram' ? item.quantity : undefined,
                    productBag: item.bag,
                    productQuality: item.quantityLevel,
                    // description: item.description,
                })),
            };


            const res = await createInventory(payload).unwrap();
            toast.success('Inventory created successfully!');
            localStorage.removeItem('inventoryItems');
            navigate('/dashboard/InventoryTable');
        } catch (err) {
            toast.error(err?.data?.message || 'Failed to create inventory');
        }
    };


    const totalPages = Math.ceil(items.length / limit);
    const paginatedItems = items.slice((currentPage - 1) * limit, currentPage * limit);


    const handleCancelNewUser = () => {
        setIsNewUser(false);
        setNewOwner("");
        setNewPhone("");
    };


    return (
        <div className={styles.createOrdersContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>Buy Items</h2>
                <span className={styles.closeIcon} onClick={handleClose}>✕</span>
            </div>

            <div className={styles.AddInvoicehead}>
                <div className={styles.formSection}>
                    <div className={styles.assignRow}>
                        <div className={styles.rightsection}>
                            {!isNewUser ? (
                                <>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Item Owner</label>

                                        <Select
                                            value={selectedFarmer}
                                            onChange={setSelectedFarmer}
                                            options={farmerOptions}
                                            formatOptionLabel={(option) => {
                                                const farmer = farmerData?.items?.find(f => f._id === option.value);
                                                if (!farmer) return option.label;
                                                const pendingAmount = farmer.totalCreditAmount || 0;
                                                return (
                                                    <span>
                                                        {farmer.storeName ? `${farmer.storeName} - ` : ""}
                                                        {farmer.phone} - {farmer.firstName}
                                                        <span style={{ color: pendingAmount > 0 ? 'red' : 'inherit', marginLeft: '5px' }}>
                                                            (Pending: ₹{pendingAmount})
                                                        </span>
                                                    </span>
                                                );
                                            }}
                                            isSearchable
                                            placeholder="Select Farmer"
                                            isLoading={isLoading}
                                            isClearable
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    height: '49px',
                                                    minHeight: '49px',
                                                    border: fieldErrors.farmerName ? '2px solid red' : provided.border,
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: 8,
                                                }),
                                                clearIndicator: (provided) => ({
                                                    ...provided,
                                                    padding: 8,
                                                }),
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    padding: '0 8px',
                                                }),
                                            }}
                                        />
                                    </div>

                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Sale Commission</label>
                                        <select
                                            className={`${styles.inputs} ${fieldErrors.saleCommission ? styles.errorInput : ''}`}
                                            value={saleCommission}
                                            onChange={(e) => setSaleCommission(e.target.value)}
                                        >
                                            <option value="">Select option</option>
                                            <option value="percentage">percentage (%)</option>
                                            <option value="price">price ($)</option>
                                        </select>
                                    </div>




                                    {/* <button
                                        type="button"
                                        className={styles.addBtn}
                                        onClick={() => setIsNewUser(true)}
                                    >
                                        + Add New User
                                    </button> */}
                                    {!selectedFarmer && (
                                        <button
                                            type="button"
                                            className={styles.addBtn}
                                            onClick={() => setIsNewUser(true)}
                                        >
                                            + New Customer    </button>
                                    )}

                                </>
                            ) : (
                                <>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Item Owner</label>
                                        <input
                                            type="text"
                                            placeholder="Enter Owner Name"
                                            className={`${styles.input} ${fieldErrors.farmerName ? styles.errorInput : ''}`}
                                            value={newOwner}
                                            onChange={(e) => setNewOwner(e.target.value)}
                                        />
                                    </div>

                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Phone Number</label>
                                        <input
                                            type="text"
                                            placeholder="Enter Phone Number"
                                            className={`${styles.input} ${fieldErrors.farmerPhone ? styles.errorInput : ''}`} // ✅ Correct key here
                                            value={newPhone}
                                            onChange={(e) => {
                                                const input = e.target.value;
                                                if (!/^\d*$/.test(input)) return;
                                                if (input.length > 10) return;
                                                if (input.length === 1 && !/^[6-9]$/.test(input)) return;
                                                setNewPhone(input);
                                            }}
                                            maxLength={10}
                                        />
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Sale Commission</label>
                                        <select
                                            className={`${styles.inputs} ${fieldErrors.saleCommission ? styles.errorInput : ''}`}
                                            value={saleCommission}
                                            onChange={(e) => setSaleCommission(e.target.value)}
                                        >
                                            <option value="">Select option</option>
                                            <option value="percentage">percentage (%)</option>
                                            <option value="price">price ($)</option>
                                        </select>
                                    </div>
                                    <div className={styles.buttonGroup}>
                                        <button
                                            type="button"
                                            className={styles.addBtn}
                                            onClick={handleCancelNewUser}
                                        >
                                            Cancel
                                        </button>

                                        {/* <button
                type="button"
                className={styles.addBtn}
                onClick={handleSaveNewUser} // existing save logic
            >
                Save
            </button> */}
                                    </div>
                                </>
                            )}
                        </div>



                        {(() => {
                            const isOwnerSelected = (!isNewUser && selectedFarmer) || (isNewUser && newOwner && newPhone);
                            if (!isOwnerSelected) return null;

                            const parts = !isNewUser ? (selectedFarmer.label?.split(" - ") || []) : [];
                            const firstName = !isNewUser ? (selectedFarmer.name || parts[parts.length - 1] || "") : newOwner;
                            const phoneNo = !isNewUser ? (selectedFarmer.phone || parts[parts.length - 2] || "") : newPhone;
                            const storeName = !isNewUser ? selectedFarmer.storeName : "";

                            return (
                                <div className={styles.ownerCard}>
                                    <p><strong>Bill To : </strong> </p>
                                    <p><strong>First Name :</strong> {firstName}</p>
                                    <p><strong>Phone No :</strong> +91-{phoneNo}</p>
                                    {storeName && (
                                        <p><strong>Store Name :</strong> {storeName}</p>
                                    )}
                                </div>
                            );
                        })()}

                    </div>

                    <div className={styles.tableHeader}>
                        {/* <div>
                            <button className={styles.addBtn} onClick={handlePrint}>
                                <FaPrint className={styles.printIcon} />
                            </button>
                        </div> */}
                        <div>
                            <button className={styles.addBtn} onClick={() => {
                                setEditItem(null);
                                setIsEditMode(false);
                                setShowAddItemPopup(true);
                            }}>
                                + Add Item
                            </button>
                        </div>
                    </div>

                    <div className={styles.tableWrapper} ref={tableRef}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Item Seq</th>
                                    <th>Item Category</th>
                                    {/* <th>Item Descriptions</th> */}
                                    <th>Item Quantity</th>
                                    <th>Item Count</th>
                                    <th>Item Quality</th>
                                    <th>Item Scales</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedItems.length === 0 ? (
                                    <tr>
                                        <td colSpan="8" className={styles.noData}>
                                            No data found
                                        </td>
                                    </tr>
                                ) : (
                                    paginatedItems.map((item, index) => (
                                        <tr key={item._id}>
                                            <td>{(currentPage - 1) * limit + index + 1}</td>
                                            <td>{item.category}</td>
                                            {/* <td>{item.description}</td> */}
                                            <td>{item.bag === 'kilogram' ? item.quantity : '-'}</td>
                                            <td>{item.bag !== 'kilogram' ? item.count : '-'}</td>
                                            <td>{item.quantityLevel}</td>
                                            <td>{item.bag}</td>
                                            <td>
                                                <div className={styles.actionsss}>
                                                    <FaEdit
                                                        className={styles.icon}
                                                        onClick={() => {
                                                            setEditItem(item);
                                                            setIsEditMode(true);
                                                            setShowAddItemPopup(true);
                                                        }}
                                                    />
                                                    <FaTrashAlt
                                                        className={styles.icon}
                                                        onClick={() => {
                                                            setItemToDelete(item);
                                                            setModalOpen(true);
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>

                        <div className={styles.paginationWrapper}>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={setCurrentPage}
                            />
                            <select
                                className={styles.inputsbtn}
                                value={limit}
                                onChange={(e) => {
                                    setLimit(Number(e.target.value));
                                    setCurrentPage(1);
                                }}
                            >
                                <option value={10}>10 rows</option>
                                <option value={25}>25 rows</option>
                                <option value={50}>50 rows</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className={styles.footerButtons}>
                    <button className={styles.cancel} onClick={handleClose}>Cancel</button>
                    {/* <button
                        className={styles.save}
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button> */}
                    <button className={styles.saves} type="button" onClick={() => setSubmitConfirmOpen(true)} >
                        Buy Items
                    </button>

                </div>

                {showAddItemPopup && (
                    <PopupWrapper onClose={() => {
                        setShowAddItemPopup(false);
                        setEditItem(null);
                        setIsEditMode(false);
                    }}>
                        <AddItemsPopup
                            onClose={() => {
                                setShowAddItemPopup(false);
                                setEditItem(null);
                                setIsEditMode(false);
                            }}
                            isEditMode={isEditMode}
                            itemData={editItem}
                        />
                    </PopupWrapper>
                )}

                {isModalOpen && (
                    <DeleteConfirmModal
                        isOpen={isModalOpen}
                        onClose={() => setModalOpen(false)}
                        onConfirm={confirmDelete}
                    />
                )}

                <DeleteConfirmModalLogout
                    isOpen={submitConfirmOpen}
                    onConfirm={() => {
                        setSubmitConfirmOpen(false);
                        handleSubmit();
                    }}
                    onCancel={() => setSubmitConfirmOpen(false)}
                    title="Are You Sure?"
                    heading="Final Submission Confirmation"
                    content="Verify the items. Once you submit, you will not be able to edit or delete the data later. Do you want to continue?"
                />

            </div>
        </div>
    );
};

export default AddNewItems;

